import PasskeyService from '../Passkey';
import { startRegistration, startAuthentication } from '@simplewebauthn/browser';

export default function usePasskey() {

    const startPasskeyPreRegister = async () => {
        let preLoginStart = await PasskeyService.preRegistrationStart();
        let credential = await startAuthentication({ optionsJSON: preLoginStart });
        let preLoginEnd = await PasskeyService.preRegistrationEnd(credential);
        return preLoginEnd;
    }

    
    
    const startPasskeyLogin = async (token) => {
        let loginStart = await PasskeyService.loginStart(token);
        let credential = await startAuthentication({ optionsJSON: loginStart });
        let loginEnd = await PasskeyService.loginEnd(credential);
        return;
    }

    const startPasskeyRegistration = async () => {
        let registrationAlreadPresent = false;
        try {
            
            await startPasskeyPreRegister();
            registrationAlreadPresent = true;
        } catch (error) {
            console.error(error);
        } 

        if(registrationAlreadPresent) {
            return;
        }


        let registrationStart = await PasskeyService.registrationStart();
        let credential = await startRegistration({ optionsJSON: registrationStart });
        let registrationEnd = await PasskeyService.registrationEnd(credential);
        return registrationEnd;
    }

    return {
        startPasskeyLogin, startPasskeyRegistration
    }

}